module.exports = __webpack_public_path__ + "static/media/projectlogo.4718cbc6.svg";